module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-spinner"
    }
  }, [_c('v-dialog', {
    attrs: {
      "ersistent": "",
      "width": "200"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#2accdd"
    }
  }, [_c('v-card-text', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticClass: "my-3",
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require('@/assets/img/launcher.png')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold ml-2"
  }, [_vm._v("Memproses Data")])]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "#0b4e79"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b04c99b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/Spinner.vue
// module id = 919
// module chunks = 1